import usePart, { type PartProps, partProps } from "../Part";
import type { FormLayout } from "@t/fd/layout/FormLayout";
import {injectComponentOfPart, injectPartRef} from "../PartInjectKeys";

export interface ContainerProps extends PartProps {
	part: FormLayout;
}

export const containerProps = {
	...partProps,
};

export default function (props: ContainerProps) {
	const partStuff = usePart(props);

	const partRef = injectPartRef();
	const componentOfPart = injectComponentOfPart();

	return {
		...partStuff,
		partRef,
		componentOfPart,
	};
}
